module.exports = __webpack_public_path__ + "static/media/user-anonymous.3aa1890b.svg";